const common = {
    login: 'Accedi',
    getStarted: 'Inizia Ora',
    learnMore: 'Scopri di Più',
    bookNow: 'Prenota Ora',
    viewDetails: 'Vedi Dettagli',
    backToTop: 'Torna Su',
    home: 'Home',
    features: 'Caratteristiche',
    yourSaaS: 'La Dolce Vita',
    day: 'Giorno',
    days: 'Giorni',
    night: 'Notte',
    nights: 'Notti',
    startingFrom: 'A partire da',
    and: 'e',
    relatedTrips: 'Viaggi Correlati',
    relatedDestinations: 'Destinazioni Correlate',
    relatedActivities: 'Attività Correlate',
    includedInTrips: 'Incluso nei Viaggi',
    availableAtDestinations: 'Disponibile nelle Destinazioni',
    includesDestinations: 'Include le Destinazioni',
    includesActivities: 'Include le Attività',
    overview: 'Panoramica',
    details: 'Dettagli',
    gallery: 'Galleria',
    related: 'Correlati',
    duration: 'Durata',
    difficulty: 'Difficoltà',
    price: 'Prezzo',
    items: 'articoli',

    locations: 'Località',
    requirements: 'Requisiti',
    included: 'Incluso',
    highlights: 'Punti di Forza',
    activities: 'Attività',
    activityNotFound: 'Attività Non Trovata',
    activityNotFoundDescription: 'L\'attività che stai cercando non esiste.',
    destinationNotFound: 'Destinazione Non Trovata',
    destinationNotFoundDescription: 'La destinazione che stai cercando non esiste.',
    productNotFound: 'Prodotto Non Trovato',
    productNotFoundDescription: 'Il prodotto che stai cercando non esiste.',
    backToHome: 'Torna alla Home',
    loading: 'Caricamento...',
    retry: 'Riprova',
    map: 'Mappa',
    region: 'Regione',
    origin: 'Origine',
    volume: 'Volume',
    additionalDetails: 'Ulteriori Dettagli',
    altitude: 'Altitudine',
    surface: 'Superficie',
    population: 'Abitanti',
    density: 'Densità',
    length: 'Lunghezza',
    aboveSeaLevel: 's.l.m.',
    updatedOn: 'aggiornato al',
    between: 'tra i',
    andMeters: 'e i',
    meters: 'metri'
};

export default common;
